<template>
  <div>
    <v-form @submit.prevent v-model="valid">
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            :value="data.price_per_day"
            @input="setKey('price_per_day', $event, parseFloat)"
            label="Preço por dia"
            prefix="R$"
            :disabled="!hasPermission(16777216) || readonly"
            type="number"
            outlined
            dense
            hide-details
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            :value="data.days"
            @input="setKey('days', $event, parseInt)"
            label="Diarias"
            type="number"
            :disabled="readonly"
            outlined
            dense
            hide-details
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            :value="data.half_day"
            @input="setKey('half_day', $event, parseInt)"
            label="Meio diárias"
            type="number"
            :disabled="readonly"
            outlined
            dense
            hide-details
          />
        </v-col>
      </v-row>

      <v-text-field
        :value="data.other_price"
        @input="setKey('other_price', $event, parseFloat)"
        label="Outros custos"
        hint="Apenas relacionados a alimentação"
        prefix="R$"
        class="mt-4"
        outlined
        dense
        :disabled="readonly"
      />
      <v-textarea
        v-if="data.other_price && data.other_price > 0"
        :value="data.other_description"
        @input="setKey('other_description', $event)"
        label="Descrição dos outros custos"
        :readonly="readonly"
        hide-details
        rows="2"
        outlined
        dense
        :rules="[(v) => !!v || 'Descrição dos outros custos é obrigatório']"
      />
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const defaultData = () => {
  return {
    days: null,
    half_day: null,
    price_per_day: 80,
    other_price: null,
    other_description: null,
  };
};

export const manifest = {
  id: "FOOD",
  name: "Alimentação",
  icon: "mdi-food",
  description: "Alimentação",
  defaultData: defaultData,
};

export default {
  name: "FoodEditor",
  props: {
    value: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: false,
    };
  },
  methods: {
    setKey(key, value, parse = false) {
      this.data = {
        ...this.data,
        [key]: !value ? value : parse ? parse(value) : value,
      };
    },
    getTotal() {
      let value = 0;
      value += this.data.days * this.data.price_per_day;
      value += (this.data.half_day * this.data.price_per_day) / 2;
      value += this.data.other_price || 0;
      return value;
    },
  },
  watch: {
    valid(value) {
      this.$emit("update:valid", value && this.getTotal() > 0);
    },
    data: {
      handler(value) {
        const amount = this.getTotal();
        this.$emit("update:amount", amount);
        this.$emit("update:valid", this.valid && amount > 0);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters("auth", ["hasPermission"]),
    data: {
      get() {
        return this.value || defaultData();
      },
      set(value) {
        this.$emit("update", value);
      },
    },
  },
  mounted() {
    this.$emit("update:valid", this.valid && this.getTotal() > 0);
  },
};
</script>
